import { useApiQuery } from './useApiQuery';

export type ConfigJobType = 'eval-set' | 'scan';

const CONFIG_API: Record<ConfigJobType, string> = {
  'eval-set': '/eval_sets',
  scan: '/scans',
};

/**
 * Load saved config for the config page and clone editor. A null jobId skips
 * the request. Report pending on the first render so the clone editor waits
 * for the config before mounting.
 */
export function useJobConfig(jobType: ConfigJobType, jobId: string | null) {
  // A one-time load: the editor owns the document once it has it, so no
  // focus refetch may replace the user's edits or flag a stale error.
  const query = useApiQuery<Record<string, unknown>>(
    `${CONFIG_API[jobType]}/${encodeURIComponent(jobId ?? '')}/config`,
    jobId !== null,
    { staleTime: Infinity, refetchOnWindowFocus: false }
  );
  return {
    config: jobId === null ? null : (query.data ?? null),
    isLoading:
      jobId !== null && !query.data && (query.isPending || query.isFetching),
    // Only a failure to load at all blocks launching; a later refetch error
    // with the config already in hand is not one.
    error: jobId === null || query.data !== undefined ? null : query.error,
    retry: () => {
      void query.refetch();
    },
  };
}
